export default __webpack_public_path__ + "static/media/background.1575eba2.png";